import { BaseModel } from '@red/data-access';
import { Expose } from 'class-transformer';
import { IScommMatrixType } from '../interfaces/comm-matrix-type.interface';


export class ScommMatrixTypeModel extends BaseModel implements IScommMatrixType {
  @Expose()
  id!: number;

  @Expose()
  code!: string;

  @Expose()
  name!: string;

  @Expose()
  status!: string;

  @Expose()
  isActive!: boolean;

  @Expose()
  createdAt!: string;

  @Expose()
  createdBy!: string;

  @Expose()
  updatedAt!: string;

  @Expose()
  updatedBy!: string

  @Expose()
  description!: string;

  @Expose()
  categoryRole!: string;
}

